// Lightweight analytics wrapper — emits to Lovable Analytics (if present),
// dispatches a global custom event, and persists "Try tool" CTA clicks to
// the backend so the admin dashboard can aggregate across all devices.
import { supabase } from "@/integrations/supabase/client";

type EventProps = Record<string, string | number | boolean | undefined>;

declare global {
  interface Window {
    lovable?: { track?: (name: string, props?: EventProps) => void };
    plausible?: (name: string, opts?: { props?: EventProps }) => void;
    gtag?: (...args: unknown[]) => void;
  }
}

export type TryClickRecord = {
  tool_id: string;
  tool_name: string;
  count: number;
  last_clicked_at: string;
  sources: Record<string, number>;
};

export function trackEvent(name: string, props: EventProps = {}) {
  try {
    window.lovable?.track?.(name, props);
    window.plausible?.(name, { props });
    window.gtag?.("event", name, props);
    window.dispatchEvent(new CustomEvent("analytics:event", { detail: { name, props } }));
  } catch {
    // no-op
  }
}

async function persistTryClickRemote(toolId: string, toolName: string, source: string) {
  try {
    await supabase.from("tool_clicks").insert({
      tool_id: toolId,
      tool_name: toolName,
      source,
    });
  } catch {
    // Network errors are silently ignored — analytics must never break UX.
  }
}

export const trackTryToolClick = (toolId: string, toolName: string, source = "card") => {
  // Fire-and-forget — do not block the outbound navigation.
  void persistTryClickRemote(toolId, toolName, source);
  trackEvent("try_tool_click", { tool_id: toolId, tool_name: toolName, source });
};
